module.exports = __webpack_public_path__ + "static/media/error.f2c0c69f.png";